module.exports = __webpack_public_path__ + "static/media/DesigningYourPersonalBrand.9c7c514b.png";